import * as Yup from "yup";
import { validation, conditionalValidation } from "../../../utils/constants";

export const OrganizationHeadCells = [
    {
        id: 'patientName',
        label: 'Patient Name',
        type: 'text',
        nested: { key: "patientName" },
        sort: true,
    },
    {
        id: 'updatedAt',
        label: 'Date & Time',
        type: 'dateTimeAmPm',
        //  nested: { key: "address", value: { index: 0, key: "line" } },
        nested: { key: "updatedAt" },
        sort: true,
    },
    // {
    //     id: 'status',
    //     label: 'Status',
    //     type: 'text',
    //     //  nested: { key: "address", value: { index: 0, key: "state" } },
    //     nested: { key: "status" },
    // },
    {
        id: 'actions',
        label: 'Actions',
        type: 'text',
        style: { textAlign: "center" },
    },
];
export const OrganizationDataFields = [
    'patientName',
    'updatedAt',
   // 'status',
    "actions"
];

export const SurveyFormikObj = {
    initialValues: {
        requestType: "Questionnaire",
        title: "",
        keyString: "",
        purpose: "",
        type: "Assessment",
        description: '',
        purpose: "survey-waitingroom",
        isDefault: true,
        question: [{
            id: Date.now(),
            text: "",
            type: "stars",
            highRateText: "",
            lowRateText: "",
            required: false,
        }]
    },
    validationSchema: Yup.object().shape({
        title: conditionalValidation(
            Yup.string().max(250, "Must be 250 characters or less").matches(/^\s*\S[\s\S]*$/, 'Only blankspaces is not valid.'),
            {
                label: "Title",
                validation,
                mandatory: true
            }),
        description: conditionalValidation(
            Yup.string().max(250, "Must be 250 characters or less").matches(/^\s*\S[\s\S]*$/, 'Only blankspaces is not valid.'),
            {
                validation,
                label: "Thank You Message",
                mandatory: true
            }),
        //  purpose: Yup.string().required("Required field"),
        question: Yup.array().of(
            Yup.object().shape({
                text: conditionalValidation(
                    Yup.string().max(250, "Must be 250 characters or less"),
                    {
                        validation,
                        label: "Survey Question",
                        mandatory: true
                    }),
                type: conditionalValidation(
                    Yup.string(),
                    {
                        validation,
                        label: "Survey Type",
                        mandatory: true
                    }),
                highRateText: conditionalValidation(
                    Yup.string().max(50, "Must be 50 characters or less"),
                    {
                        validation
                    }),
                lowRateText: conditionalValidation(
                    Yup.string().max(50, "Must be 50 characters or less"),
                    {
                        validation
                    }),
                required: Yup.boolean(),
                // Add more validations for other item properties if needed
            })
        ),
    }),
}


export const EditSurveyFormikObj = {
    initialValues: {
        requestType: "Questionnaire",
        title: "",
        keyString: "",
        purpose: "survey-waitingroom",
        type: "Assessment",
        description: '',
        isDefault: true,
        question: [{
            id: Date.now(),
            text: "",
            type: "stars",
            highRatingText: "",
            lowRatingText: "",
            required: false,
        }]
    },
    validationSchema: Yup.object().shape({
        title: conditionalValidation(
            Yup.string().max(250, "Must be 250 characters or less").matches(/^\s*\S[\s\S]*$/, 'Only blankspaces is not valid.'),
            {
                validation,
                label: "Title",
                mandatory: true
            }),
        description: conditionalValidation(
            Yup.string().max(250, "Must be 250 characters or less").matches(/^\s*\S[\s\S]*$/, 'Only blankspaces is not valid.'),
            {
                validation,
                label: "Thank You Message"
            }),
        //  purpose: Yup.string().required("Required field"),
        question: Yup.array().of(
            Yup.object().shape({
                text: conditionalValidation(
                    Yup.string().max(250, "Must be 250 characters or less").required('Please fill the Survey Question field'),
                    {
                        validation,
                        mandatory: true,
                        label: "Survey Question"
                    }),
                type: conditionalValidation(
                    Yup.string(),
                    {
                        validation,
                        label: "Survey Type",
                        mandatory: true
                    }),
                highRatingText: conditionalValidation(
                    Yup.string().max(50, "Must be 50 characters or less"),
                    {
                        validation,
                        label: "High Rating Text"
                    }),
                lowRatingText: conditionalValidation(
                    Yup.string().max(50, "Must be 50 characters or less"),
                    {
                        validation,
                        label: "Low Rating Text"
                    }),
                required: Yup.boolean(),
                // Add more validations for other item properties if needed
            })
        )
    }),
}

export const purposeOption = [
    { value: "survey-waitingroom", name: "Survey" },
]



export const answerTypeOptions = [
    { value: "stars", name: "Stars" },
    { value: "freeText", name: "Multi Line Text" },
    { value: "singleFreeText", name: "Single Line Text" },
]
export const SurveyMessageHeadCells = [
    {
        id: 'title',
        label: 'Survey Message',
        type: 'text',
        nested: { key: "title" },
    },
];
export const SurveyMessageDataFields = [
    'title'
];
export const SurveyQuestionHeadCells = [
    {
        id: 'text',
        label: 'Survey Question',
        type: 'text',
        // nested: { key: "item" },
        nested: { key: "text", },
        style: { width: "100%" },
    },
    {
        id: 'type',
        label: 'Answer Type',
        type: 'text',
        // nested: { key: "name" },
        style: { whiteSpace: "nowrap" },
        nested: { key: "type" },
    },
];


export const SurveyQuestionDataFields = [
    'text',
    // 'type' && 'type' == 'freeText' ? 'type' == 'Free Text' : 'type' == 'starts' ? 'type' == 'Stars' :'',
    'type'
];
export const SurveyThankYouHeadCells = [
    {
        id: 'description',
        label: 'Thank You Message',
        type: 'text',
        nested: { key: "description" },
    },
];
export const SurveyThankYouDataFields = [
    'description',
];

export const validateNotBlank = (value) => {
    if (!value || value.trim() === '') {
        return 'This field cannot be blank.';
    }
    return undefined; // Return undefined to indicate that the field is valid
};

export const surveyForOptionsOrganization = [
    { value: "survey-waitingroom", name: "Get Care - Waiting Room" },
];

export const SurveyFormikAssign = {
    initialValues: {
        //  questionnaire: "",
        questionnaireWroomField: "",
        type: "survey",
        purpose: "",
    },
    validationSchema: Yup.object({
        // questionnaire: Yup.string().required('Please select  field'),
        //  purpose: Yup.string().required('Please select field'),
    }),
}



